export default "__VITE_ASSET__B0Hop_zP__"